import React from "react";
import { Container, Row, Col, Placeholder } from "react-bootstrap";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { RootState } from "../reducers";
import useTenant from "../tenant/useTenant";

const Footer = () => {
  const tenant = useTenant();
  const menuProducts = useSelector(
    (state: RootState) => state.shop.menuProducts,
  );

  const handleScrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer
      className="mt-5 py-5"
      style={{ backgroundColor: "#f8f9fa", borderTop: "1px solid #e9ecef" }}
    >
      <Container>
        <Row>
          {!menuProducts || menuProducts.length === 0
            ? Array.from({ length: 4 }).map((_, idx) => (
                <Col key={idx} lg={3} md={4} sm={6} xs={6} className="mb-4">
                  <Placeholder as="h6" animation="glow" className="mb-3">
                    <Placeholder xs={7} />
                  </Placeholder>
                  <ul className="list-unstyled">
                    {Array.from({ length: 4 }).map((_, liIdx) => (
                      <li key={liIdx} className="mb-2">
                        <Placeholder as="div" animation="glow">
                          <Placeholder xs={5 + (liIdx % 3) * 2} />
                        </Placeholder>
                      </li>
                    ))}
                  </ul>
                </Col>
              ))
            : menuProducts.map((parent) => (
                <Col
                  key={parent.id}
                  lg={3}
                  md={4}
                  sm={6}
                  xs={6}
                  className="mb-4"
                >
                  <h6
                    className="mb-3"
                    style={{
                      fontWeight: 700,
                      fontSize: "0.9rem",
                      letterSpacing: "0.5px",
                      textTransform: "uppercase",
                      color: "#333",
                    }}
                  >
                    <Link
                      to={`/product-type/${parent.id}`}
                      className="text-decoration-none text-dark"
                      onClick={handleScrollToTop}
                    >
                      {parent.name}
                    </Link>
                  </h6>
                  <ul className="list-unstyled">
                    {parent.children?.map((child) => (
                      <li key={child.id} className="mb-2">
                        <Link
                          to={`/product-type/${child.id}`}
                          className="text-decoration-none text-secondary"
                          onClick={handleScrollToTop}
                          style={{
                            fontSize: "0.85rem",
                            textTransform: "capitalize",
                          }}
                        >
                          {child.name.toLowerCase()}
                        </Link>
                        {child.children?.length > 0 && (
                          <ul className="list-unstyled ms-2 mt-1 border-start ps-2">
                            {child.children.map((subchild) => (
                              <li key={subchild.id} className="mb-1">
                                <Link
                                  to={`/product-type/${subchild.id}`}
                                  className="text-decoration-none text-muted"
                                  onClick={handleScrollToTop}
                                  style={{
                                    fontSize: "0.85rem",
                                    fontWeight: 400,
                                    textTransform: "capitalize",
                                  }}
                                >
                                  {subchild.name.toLowerCase()}
                                </Link>
                              </li>
                            ))}
                          </ul>
                        )}
                      </li>
                    ))}
                  </ul>
                </Col>
              ))}
          <Col lg={3} md={4} sm={6} xs={6} className="mb-4">
            <h6
              className="mb-3"
              style={{
                fontWeight: 700,
                fontSize: "0.9rem",
                letterSpacing: "0.5px",
                textTransform: "uppercase",
                color: "#333",
              }}
            >
              <Link
                to="/product-type/weekly"
                className="text-decoration-none text-dark"
                onClick={handleScrollToTop}
              >
                Nuevos Ingresos
              </Link>
            </h6>
          </Col>
        </Row>

        <Row className="mt-4 pt-4 border-top">
          <Col
            xs={12}
            className="text-center text-muted"
            style={{ fontSize: "0.8rem" }}
          >
            &copy; {new Date().getFullYear()} {tenant.brandName}. Todos los
            derechos reservados.
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
